import React from "react";
import { Field } from "redux-form";
import classNames from "classnames";

import { IMedia } from "../../../types";
import { media } from "../../../utils/StrapiUtils";
//Field трансформируется в Input(type=radio)

//Name = Наименование для бекенда
//Value = Значение переменной, которое будет записано, если нажать на кнопку(записано в бек)
//id = Айди для определения лейбла и Radio button, чтобы при нажатии на label кнопка radio тоже нажималась
//func = функция, передаваемая в кнопку(это нужно для фронта по моей части)
//txt = Наименование, типо (стекло, зеркало и т.д.)

interface ICheckBox {
  name: string;
  value?: string;
  func?: () => void;
  txt?: string;
  onCheck: (bool: boolean) => void;
  width?: boolean;
  info?: {
    text: string;
    img?: IMedia;
  };
}
export default ({
  name,
  onCheck,
  value,
  func,
  txt = "",
  width = false,
  info = null,
}: ICheckBox) => {
  const imgUrl = media(info?.img)?.src;
  return (
    <div className={classNames("calc_checker_box", { widthTrue: width })}>
      <Field
        className="calc_checker"
        component={"input"}
        value={value}
        onClick={(e: React.ChangeEvent<HTMLInputElement>) => {
          onCheck(e.target.checked);
          func?.();
        }}
        name={name}
        id={name}
        type={"checkbox"}
      />
      <label className="calc_checker_text" htmlFor={name}>
        {txt}
      </label>
      {info && (
        <>
          <div className="calc_question">?</div>
          <div className="question_popup">
            <div className="question_popup_head">
              <div className="question_popup_head_text">{txt}</div>
            </div>
            <div className="question_popup_content">
              {info?.text && (
                <div className="question_popup_content_text">{info.text}</div>
              )}
              {imgUrl && (
                <img
                  className="question_popup_content_img"
                  src={imgUrl}
                  alt={info.img?.alternativeText}
                />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
